import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';

import Register from './components/auth/Register';
import Login from './components/auth/Login';
import ResetPasswordPage from './pages/auth/ResetPasswordPage';
import Projects from './ProjectsDemo';
import ProtectedAdminRoute from './components/ProtectedAdminRoute';
import AdminPage from './pages/admin/AdminPage';
import PublicDashboardPage from './pages/dashboards/PublicDashboardPage';
import { ENABLE_ADMIN_SECTION, ENABLE_DASHBOARDS } from './config/features';

const PublicRoutes = ({
  userIdToken,
  projectIdToken,
  onLogin,
  onProjectAccess,
  handleStorageChange,
  isTeamsInitialized,
}) => {
  return (
    <div className="app">
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route
          path="/login"
          element={
            <Login onLogin={onLogin} isTeamsInitialized={isTeamsInitialized} />
          }
        />
        {/* Route always registered — backend enforces who can complete signup */}
        <Route path="/sign-up" element={<Register onLogin={onLogin} />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        {/* Public dashboard snapshot links: no sign-in. */}
        {ENABLE_DASHBOARDS && (
          <Route path="/d/:token" element={<PublicDashboardPage />} />
        )}
        <Route path="*" element={<Navigate to="/login" />} />

        {/* Conditional routes */}
        {userIdToken && (
          <Route
            path="/projects"
            element={
              <Projects
                userIdToken={userIdToken}
                onProjectAccess={onProjectAccess}
                handleStorageChange={handleStorageChange}
              />
            }
          />
        )}
        {userIdToken && (
          <Route
            path="/projects"
            element={
              <Projects
                userIdToken={userIdToken}
                onProjectAccess={onProjectAccess}
                handleStorageChange={handleStorageChange}
              />
            }
          />
        )}

        {/* Pass userIdToken to the protected route wrapper */}
        {userIdToken && ENABLE_ADMIN_SECTION && (
          <Route
            path="/admin"
            element={
              <ProtectedAdminRoute userIdToken={userIdToken}>
                <AdminPage />
              </ProtectedAdminRoute>
            }
          />
        )}

        {!userIdToken && <Route path="*" element={<Navigate to="/login" />} />}
        {userIdToken && (
          <Route path="*" element={<Navigate to="/projects" />} />
        )}
      </Routes>
    </div>
  );
};

export default PublicRoutes;
